import { CommonModule } from "@angular/common";
import { Component, Input, OnDestroy, SimpleChanges, TemplateRef, type OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { Subscription } from "rxjs";
import { lovsActions, selectData, selectLoadingStateData } from "../../../store";
import { NoDataComponent } from "../../ui";

@Component({
    selector: "sms-list-with-pagination",
    standalone: true,
    imports: [CommonModule, NoDataComponent, ProgressSpinnerModule],
    templateUrl: "./list-with-pagination.component.html",
    styleUrls: ["./list-with-pagination.component.scss"],
})
export class ListWithPaginationComponent implements OnInit, OnDestroy {
    @Input() bodyRef?: TemplateRef<any>;
    @Input() headerRef?: TemplateRef<any>;
    @Input() key: string;

    pg = 0;
    limit = 10;

    data: { rows: any[]; count: 0 };

    subscription = new Subscription();

    loading: boolean = false;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.subscription.add(
            this.store.select(selectData).subscribe((values) => {
                if (values[this.key]) {
                    this.data = values[this.key];
                }
            }),
        );
        this.subscription.add(
            this.store.select(selectLoadingStateData).subscribe((values) => {
                this.loading = values[this.key] || false;
            }),
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["key"].currentValue) {
            this.resetQueryParams();
            this.store.dispatch(
                lovsActions.getLovData({
                    data: { url: changes["key"].currentValue, queryParams: this.queryParams, skipCache: true },
                }),
            );
        }
    }

    resetQueryParams() {
        this.pg = 0;
        this.limit = 10;
    }

    get queryParams() {
        return {
            pg: this.pg,
            limit: this.limit,
        };
    }

    get hasMore() {
        return Math.ceil(this.data.count / this.limit) - 1 === this.pg;
    }

    onNext() {
        this.pg = this.pg + 1;
        this.store.dispatch(
            lovsActions.getLovData({ data: { url: this.key, queryParams: this.queryParams, skipCache: true } }),
        );
    }

    onPrev() {
        this.pg = this.pg - 1;
        this.store.dispatch(
            lovsActions.getLovData({ data: { url: this.key, queryParams: this.queryParams, skipCache: true } }),
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
